
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface NotLoggedInMessageProps {
  message?: string;
}

const NotLoggedInMessage: React.FC<NotLoggedInMessageProps> = ({ 
  message = "Please log in to access this page"
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] p-6 text-center">
      <h2 className="text-2xl font-bold mb-4">Not Logged In</h2>
      <p className="text-muted-foreground mb-6 max-w-md">{message}</p>
      <div className="flex gap-4">
        <Button onClick={() => navigate("/login")}>
          Log In
        </Button>
        <Button variant="outline" onClick={() => navigate("/register")}>
          Register
        </Button>
      </div>
    </div>
  );
};

export default NotLoggedInMessage;
